var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngleRightTemp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.10005 16.1C0.80005 16.1 0.50005 16 0.30005 15.8C-0.09995 15.4 4.98891e-05 14.8 0.40005 14.4L7.50005 8.20005L0.40005 1.80005C4.98891e-05 1.40005 -0.09995 0.80005 0.30005 0.40005C0.70005 5.00083e-05 1.30005 -0.0999501 1.70005 0.30005L9.70005 7.30005C9.90005 7.50005 10 7.80005 10 8.10005C10 8.40005 9.90005 8.70005 9.70005 8.90005L1.70005 15.9C1.50005 16 1.30005 16.1 1.10005 16.1Z",
    fill: "#898B94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRightTemp);
export default __webpack_public_path__ + "static/media/angle-right-temp.0e4a67a1c41782e65ce86c65b92be5ab.svg";
export { ForwardRef as ReactComponent };